import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
`

export const TableContainer = styled.div`
  height: calc(100% - 60px);
`

export const tableRow = css`
  cursor: default;
  overflow: hidden;
`

export const tableCell = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const statusContainer = css`
  display: flex;
`
